import 'expose-loader?jQuery!jquery';
import '../node_modules/signalr/jquery.signalR.js';
import "babel-polyfill";

declare var module: any;

// HMR for development
if (module.hot) {
    module.hot.accept();
}

import "@progress/kendo-ui/css/web/kendo.common.less";
import "@progress/kendo-ui/css/web/kendo.materialblack.less";

import "./app.less";

import { getEndpoints, buildUserManagers, anonymousBootstrap, bootstrapAnonymousApplication, bootstrapAuthorizedApplication } from './zbootstrap';

$.getScript("signalr/hubs").then(() => {
    getEndpoints().then(endpoints => {
        if (process.env.NODE_ENV === "dev") {            
            $.connection.hub.url = 'https://localhost:9000/signalr';
        }

        const userManagers = buildUserManagers(endpoints.adminEndpoint, endpoints.webEndpoint, endpoints.idpEndpoint);

        if (anonymousBootstrap(window.location.href)) {
            bootstrapAnonymousApplication(userManagers.adminUserManager);
        } else {
            userManagers.adminUserManager.getUser().then(user => {
                if (user === null) {
                    userManagers.adminUserManager.signinRedirect().then(null,
                        reason => {
                            console.error(`Error while redirect to login page (${JSON.stringify(reason)})`);
                        });
                } else {

                    if (!!endpoints.idpEndpoint) {
                        const webEndpoint = endpoints.webEndpoint.endsWith('/')
                            ? endpoints.webEndpoint
                            : endpoints.webEndpoint + '/';
                        const isAdminKey = `isAdmin_${webEndpoint}`.toLowerCase();

                        let isAdmin = false;
                        for (const key in user.profile) {
                            if (key.toLowerCase() === isAdminKey) {
                                isAdmin = !!user.profile[key] ? (user.profile[key].toLowerCase() === 'true') : false;
                                break;
                            }
                        }

                        if (!isAdmin) {
                            // Se non ha i permessi per accedere all'admin tool viene rediretto sull'istanza Board
                            window.location.href = webEndpoint;
                        }
                    }

                    bootstrapAuthorizedApplication(userManagers.adminUserManager,
                        user,
                        userManagers.webUserManager,
                        endpoints.webEndpoint,
                        endpoints.idpEndpoint
                    );
                }
            });
        }
    },
        reason => {
            console.error("Unable to contact API to get client informations");
            console.error(reason);
        });
});


// WEBPACK FOOTER //
// ./app/index.ts